import template from './mapLocationForm.html';
import controller from './mapLocationForm.controller';
import './mapLocationForm.scss';

let mapLocationFormComponent = {
  restrict: 'E',
  bindings: {
    validation: '<',
    location: '=',
    save: '&',
    storeFile: '&',
    removeFile: '&',
    addKeyword: '&',
    removeKeyword: '&',
    locationAccesses: '<',
    locationFilters: '<',
    locationTypes: '<'
  },
  template,
  controller
};

export default mapLocationFormComponent;
